export const useTimeZone = () => {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
};
